module.exports = __webpack_public_path__ + "static/media/user.eb5a9f34.png";